import React from 'react';
import { ButtonColor, ButtonLayoutProps, ButtonSize } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import cssStyles from './Button.module.scss';
import ShadcnButtonLayout from './ShadcnButtonLayout';

function LegacyButtonLayout(props: ButtonLayoutProps) {
  const isDisabled = () => {
    return !!props.isDisabled;
  };

  const color = props.color || ButtonColor.GREEN;
  const size = props.size || ButtonSize.MEDIUM;

  const stylesValues = [];

  stylesValues.push(`btn-${size.toLowerCase()}`);
  stylesValues.push(`btn-${color}`);
  if (props.isFilled) {
    stylesValues.push('btn-filled');
  }

  if (props.isFlat) {
    stylesValues.push('btn-flat');
  }

  if (props.isDisabled) {
    stylesValues.push('btn-disabled');
  }

  if (props.iconType) {
    stylesValues.push(`btn-${props.iconType}`);
  }

  const className = props.className || `${cssStyles.button} ${stylesValues.join(' ')} ${props.customClass || ''} ${props.isLoading ? cssStyles.loading : ''}`

  const renderContent = () => {
    if (props.image) {
      return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
          <span style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {props.isLoading ? (
              <i className="fa fa-spinner fa-spin" style={{ fontSize: '16px' }} />
            ) : (
              props.image
            )}
          </span>
          <span>{props.text}</span>
        </span>
      );
    }

    return (
      <>
        {props.isLoading && (
          <i
            className="fa fa-spinner fa-spin"
            style={{
              marginLeft: '0.5rem',
              marginRight: '0.5rem',
              display: 'inline-block',
            }}
          />
        )}
        {props.text}
      </>
    );
  };

  return (
    <button
      type={props.isSubmitButton ? 'submit' : 'button'}
      className={className}
      onClick={(event) => {
        event.preventDefault();
        if (props.onClick) {
          props.onClick();
        }
      }}
      disabled={isDisabled()}
      ref={props.elementRef}
      title={props.title}
      data-testid={props.testId}
    >
      {renderContent()}
    </button>
  );
}

export default function ButtonLayout(props: ButtonLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnButtonLayout {...props} />;
  } else {
    return <LegacyButtonLayout {...props} />;
  }
}
